// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-button[data-v-a2c543cc]{letter-spacing:.5px;text-transform:unset;height:auto!important}.custom-button[data-v-a2c543cc] i{margin-bottom:.125rem;margin-left:.25rem}.custom-button[data-v-a2c543cc] .v-btn__content{white-space:normal;text-align:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
